"use client";

import { useIntl } from "react-intl";

import FormItem from "forms/fields/FormItem";
import type { FormControlType } from "types/formType";
import { predefinedFields } from "types/predefinedFields";
import type { IFormInputs } from "types/uiSchema";
import { Fieldset } from "ui/Fieldset";
import { FormField } from "uiShadcn/form";
import { Input } from "uiShadcn/input";

interface RecommendingPersonProps {
    control: FormControlType;
    uiData: IFormInputs;
}

export default function RecommendingPerson({ control, uiData }: RecommendingPersonProps) {
    const { formatMessage } = useIntl();
    const isRequired = uiData?.required?.includes("true");

    return (
        <Fieldset title={formatMessage({ id: "recommendingPerson" })}>
            <FormField
                control={control}
                name={predefinedFields.recommendingPerson}
                render={({ field }) => (
                    <FormItem label={formatMessage({ id: "recommendingPersonInfo" })} required={isRequired}>
                        <Input
                            {...field}
                            type="text"
                            dataTestId={predefinedFields.recommendingPerson}
                            placeholder={formatMessage({
                                id: "enter",
                            })}
                            required={isRequired}
                        />
                    </FormItem>
                )}
            />
        </Fieldset>
    );
}
